document.addEventListener('DOMContentLoaded', function () {
  // Check if the screen is desktop width (Dawn's desktop breakpoint is 990px)
  const isDesktop = () => window.innerWidth >= 990;

  // Select all menu dropdowns inside the header
  const menuDetails = document.querySelectorAll("header-menu details");

  menuDetails.forEach((detail) => {
    const summary = detail.querySelector("summary");

    // 1. Open the menu when the mouse enters
    detail.addEventListener("mouseenter", () => {
      if (!isDesktop()) return;
      detail.setAttribute("open", "");
      if (summary) summary.setAttribute("aria-expanded", "true");
    });

    // 2. Close the menu when the mouse leaves
    detail.addEventListener("mouseleave", () => {
      if (!isDesktop()) return;
      detail.removeAttribute("open");
      if (summary) summary.setAttribute("aria-expanded", "false");
    });

    // 3. Prevent clicking from closing the menu while hovering
    if (summary) {
      summary.addEventListener("click", (e) => {
        if (isDesktop()) {
          e.preventDefault();
        }
      });
    }
  });

  const scrollers = document.querySelectorAll(".js-logo__container");
  if (scrollers.length > 0) addAnimation();
  function addAnimation() {
    scrollers.forEach((scroller) => {
      scroller.setAttribute("data-animated", true);
      const scrollerInner = scroller.querySelector(".logo__wrapper");
      const scrollerContent = Array.from(scrollerInner.children);
      scrollerContent.forEach((item) => {
        const duplicatedItem = item.cloneNode(true);
        duplicatedItem.setAttribute("aria-hidden", true);
        scrollerInner.appendChild(duplicatedItem);
      });
    });
  }

  // Counter Animation
  const sections = document.querySelectorAll(".js-counter-custom");
  const observerOptions = {
    threshold: 0.5,
  };
  const observer = new IntersectionObserver((entries, observerInstance) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        // Find only the counters INSIDE the section that just became visible
        const sectionCounters = entry.target.querySelectorAll(".counter");
        
        sectionCounters.forEach((counter) => {
          animateCounter(counter);
        });

        // Stop observing this specific section so the animation only runs once
        observerInstance.unobserve(entry.target);
      }
    });
  }, observerOptions);
  sections.forEach((section) => {
    observer.observe(section);
  });
  function formatNumber(num) {
    return num.toLocaleString("en-US");
  }
  function animateCounter(counter) {
    const target = +counter.getAttribute("data-target");
    const prefix = counter.getAttribute("data-prefix") || "";
    const suffix = counter.getAttribute("data-suffix") || "";
    const duration = 2000; // 2 seconds
    const startTime = performance.now();

    function update(currentTime) {
      const elapsed = currentTime - startTime;
      const progress = Math.min(elapsed / duration, 1);
      
      // Calculate the current value based on progress
      const currentValue = Math.floor(progress * target);

      // Apply prefix, formatted number (with commas), and suffix
      counter.textContent = prefix + formatNumber(currentValue) + suffix;

      if (progress < 1) {
        requestAnimationFrame(update);
      } else {
        // Ensure we end exactly on the target number
        counter.textContent = prefix + formatNumber(target) + suffix;
      }
    }

    requestAnimationFrame(update);
  }

  // Phone Number Format
  const phoneInputs = document.querySelectorAll('input[type="tel"]');

  if (phoneInputs) {
    phoneInputs.forEach(phoneInput => {
      phoneInput.addEventListener('input', function(e) {
        const x = phoneInput.value.replace(/\D/g, '').substring(0,10);
        
        if (x.length === 0) {
          phoneInput.value = '';
          return;
        }
        
        // Build the formatted string with underscores for missing digits
        const template = '(___) ___-____';
        const chars = x.split('');
        const positions = [1, 2, 3, 6, 7, 8, 10, 11, 12, 13]; // positions where digits go
        const result = template.split('');
        
        for (let i = 0; i < chars.length && i < positions.length; i++) {
          result[positions[i]] = chars[i];
        }
        
        phoneInput.value = result.join('');
        
        // Set cursor position
        let cursorPos = 1;
        if (chars.length > 0) cursorPos = positions[Math.min(chars.length - 1, positions.length - 1)] + 1;
        if (chars.length >= 3 && cursorPos <= 4) cursorPos = 6;
        if (chars.length >= 6 && cursorPos <= 9) cursorPos = 10;
        
        phoneInput.setSelectionRange(cursorPos, cursorPos);
      });

      phoneInput.addEventListener('keydown', function(e) {
        // Handle backspace
        if (e.key === 'Backspace') {
          e.preventDefault();
          let x = phoneInput.value.replace(/\D/g, '');
          if (x.length > 0) {
            x = x.substring(0, x.length - 1);
            if (x.length === 0) {
              phoneInput.value = '';
            } else {
              // Trigger input event to reformat
              var inputEvent = new Event('input', { bubbles: true });
              phoneInput.value = x;
              phoneInput.dispatchEvent(inputEvent);
            }
          }
        }
      });
    });
    
  }

  // Star Rating
  const starRating = document.querySelectorAll('.star-rating');
  if (starRating.length > 0) {
    starRating.forEach(container => {
      const rating = parseFloat(container.dataset.rating) || 0;

      for (let i = 1; i <= 5; i++) {
        const star = document.createElement('div');
        star.className = 'star';

        const inner = document.createElement('div');
        inner.className = 'star-inner';

        const fill = Math.max(0, Math.min(1, rating - (i - 1))) * 100;
        inner.style.width = fill + '%';

        star.appendChild(inner);
        container.appendChild(star);
      }
    });
  }

  // Accordion
  const accordionGroups = document.querySelectorAll(".accordion-group");
  accordionGroups.forEach((group) => {
    const headers = group.querySelectorAll(".accordion-header");
    const accordions = group.querySelectorAll(".accordion");
    let currentlyActive = group.querySelector(".accordion.active");

    // Helper to check if the static class is present in the parent container
    function isStaticMode() {
      const container = group.closest(".accordion-slider__container");
      const hasStaticClass = container && container.querySelector(".accordion-slider__splide--static") !== null;
      
      // Check if the viewport is 767px or smaller
      const isMobile = window.matchMedia("(max-width: 767px)").matches;

      // Only return true if BOTH conditions are met
      return hasStaticClass && isMobile;
    }

    // Handle setting heights for initial load and window resizes
    function updateHeights() {
      const staticMode = isStaticMode();

      if (staticMode) {
        // If static: Open all accordions
        accordions.forEach((acc) => {
          const content = acc.querySelector(".accordion-content");
          const button = acc.querySelector(".accordion-header");
          const panel = acc.closest(".faq-tabs__panel");
          const wasHidden = panel && !panel.classList.contains("is-active");

          if (wasHidden) panel.style.display = "block";

          acc.classList.add("active");
          button.setAttribute("aria-expanded", "true");
          content.style.transition = "none";
          content.style.maxHeight = content.scrollHeight + "px";
          content.offsetHeight; // Force reflow
          content.style.transition = "";

          if (wasHidden) panel.style.display = "";
        });
      } else {
        // If not static: Ensure only one accordion is open (useful when resizing back to desktop)
        let activeCount = 0;
        accordions.forEach((acc) => {
          const content = acc.querySelector(".accordion-content");
          const button = acc.querySelector(".accordion-header");

          if (acc.classList.contains("active")) {
            if (activeCount === 0) {
              // Keep the first active one open and recalculate its height
              currentlyActive = acc;
              const panel = acc.closest(".faq-tabs__panel");
              const wasHidden = panel && !panel.classList.contains("is-active");

              if (wasHidden) panel.style.display = "block";
              content.style.transition = "none";
              content.style.maxHeight = content.scrollHeight + "px";
              content.offsetHeight; 
              content.style.transition = "";
              if (wasHidden) panel.style.display = "";

              activeCount++;
            } else {
              // Close any extra accordions that were forced open by mobile view
              acc.classList.remove("active");
              button.setAttribute("aria-expanded", "false");
              content.style.transition = "none";
              content.style.maxHeight = "0px";
              content.offsetHeight;
              content.style.transition = "";
            }
          }
        });
      }
    }

    // 1. Initialize heights on load
    updateHeights();

    function toggleAccordion(accordion) {
      // 2. Prevent clicking/closing if in static mode
      if (isStaticMode()) return;

      const isActive = accordion.classList.contains("active");
      const button = accordion.querySelector(".accordion-header");
      const content = accordion.querySelector(".accordion-content");

      // Close if clicking the active one
      if (accordion === currentlyActive) {
        content.style.maxHeight = "0px";
        accordion.classList.remove("active");
        button.setAttribute("aria-expanded", "false");
        currentlyActive = null;
        return;
      }

      // Close previously active accordion in this group
      if (currentlyActive) {
        const activeContent = currentlyActive.querySelector(".accordion-content");
        const activeButton = currentlyActive.querySelector(".accordion-header");

        activeContent.style.maxHeight = "0px";
        currentlyActive.classList.remove("active");
        activeButton.setAttribute("aria-expanded", "false");
      }

      // Open new accordion
      accordion.classList.add("active");
      button.setAttribute("aria-expanded", "true");
      content.style.maxHeight = content.scrollHeight + "px";
      currentlyActive = accordion;
    }

    headers.forEach((header, index) => {
      header.addEventListener("click", () => {
        toggleAccordion(header.parentElement);
      });

      header.addEventListener("keydown", (e) => {
        if (e.key === "Enter" || e.key === " ") {
          e.preventDefault();
          toggleAccordion(header.parentElement);
        }

        if (e.key === "ArrowDown" || e.key === "ArrowUp") {
          e.preventDefault();
          const nextIndex =
            e.key === "ArrowDown"
              ? (index + 1) % headers.length
              : (index - 1 + headers.length) % headers.length;

          headers[nextIndex].focus();
        }

        if (e.key === "Home") {
          e.preventDefault();
          headers[0].focus();
        }

        if (e.key === "End") {
          e.preventDefault();
          headers[headers.length - 1].focus();
        }
      });
    });

    // 3. Resize handling recalculates based on static state
    window.addEventListener("resize", () => {
      updateHeights();
    });
  });

  // Video Popup
  document.addEventListener('click', function (e) {
    const playButton = e.target.closest('.play-button');
    if (!playButton) return;

    const wrapper = playButton.closest('[data-video]');
    const video = wrapper.querySelector('video, iframe');

    wrapper.classList.add('is-playing');

    if (video.tagName === 'VIDEO') {
      video.muted = false;
      video.currentTime = 0;
      video.play();
    }

    if (video.tagName === 'IFRAME') {
      const src = video.getAttribute('src');

      if (src.includes('youtube')) {
        video.src = src.replace('mute=1', 'mute=0') + '&autoplay=1';
      }

      if (src.includes('vimeo')) {
        video.src = src.replace('muted=1', 'muted=0') + '&autoplay=1';
      }
    }
  });

  const popup = document.getElementById("video-popup");
  if (popup) {
    const popupInner = popup.querySelector(".video-popup__inner");

    document.addEventListener("click", function (event) {
      // Open popup when clicking wrapper
      const wrapper = event.target.closest(".video__wrapper");
      if (wrapper) {
        const playBtn = wrapper.querySelector(".video-play-btn");
        if (!playBtn) return;

        const videoHtml = playBtn.getAttribute("data-video-html");

        popupInner.innerHTML = videoHtml;
        popup.classList.add("active");

        return;
      }

      // Close popup
      if (
        event.target.closest(".video-popup__close") ||
        event.target.closest(".video-popup__overlay")
      ) {
        popup.classList.remove("active");
        popupInner.innerHTML = "";
      }
    });
  }

  const tabWidgets = document.querySelectorAll(
    '.media-with-text-tab__container, .product-description-tab, .table-with-tab__container'
  );

  tabWidgets.forEach((widget) => {
    const tabTitles = widget.querySelectorAll('.media-with-text__heading[data-tab-title-toggle]');
    const tabs = widget.querySelectorAll('.custom-tab-tab__header-tab[data-tab]');
    const panels = widget.querySelectorAll('.custom-tab__tab-panel');

    if (tabs.length === 0) return;

    function scrollToTarget() {
      const isMobile = window.innerWidth <= 768;
      const target = isMobile
        ? widget.querySelector('.media-with-text-tab__dropdown, .table-with-tab__dropdown')
        : widget.querySelector('.media-with-text-tab__content, .table-with-tab__content');

      // product-description-tab has none of these — just skip scrolling
      if (!target) return;

      const header = document.querySelector('.section-header');
      const headerHeight = header ? header.getBoundingClientRect().height : 0;

      const targetEl = widget.querySelector('.media-with-text-tab__wrapper, .table-with-tab__wrapper') || widget;
      const targetPosition = targetEl.getBoundingClientRect().top + window.scrollY;

      window.scrollTo({
        top: targetPosition - headerHeight - 10,
        behavior: 'smooth',
      });
    }

    tabs.forEach(tab => {
      tab.addEventListener('click', function () {
        const tabIndex = this.getAttribute('data-tab');
        const tabTitle = this.getAttribute('data-tab-title');

        tabs.forEach(t => {
          t.classList.remove('active');
          t.setAttribute('aria-selected', 'false');
        });
        this.classList.add('active');
        this.setAttribute('aria-selected', 'true');

        panels.forEach((panel, index) => {
          if (index == tabIndex) {
            panel.classList.add('active');
            panel.removeAttribute('hidden');
          } else {
            panel.classList.remove('active');
            panel.setAttribute('hidden', '');
            panel.querySelector('.content__wrapper')?.classList.remove('triggered');
            panel.querySelector('.media__wrapper')?.classList.remove('triggered');
          }
        });

        tabTitles.forEach((title) => {
          if (title.getAttribute('data-tab-title-toggle') == tabTitle) {
            title.classList.add('active');
            title.removeAttribute('hidden');
          } else {
            title.classList.remove('active');
            title.setAttribute('hidden', '');
          }
        });

        scrollToTarget();
      });

      tab.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          this.click();
        }
        if (e.key === 'ArrowRight') {
          e.preventDefault();
          const nextTab = this.nextElementSibling || tabs[0];
          nextTab.focus();
          nextTab.click();
        }
        if (e.key === 'ArrowLeft') {
          e.preventDefault();
          const prevTab = this.previousElementSibling || tabs[tabs.length - 1];
          prevTab.focus();
          prevTab.click();
        }
      });
    });

    const dropdown = widget.querySelector('.media-with-text-tab-select');
    if (dropdown) {
      dropdown.addEventListener('change', function () {
        if (tabs[this.value]) tabs[this.value].click();
      });
    }

    const dropdown2 = widget.querySelector('.table-with-tab-select');
    if (dropdown2) {
      dropdown2.addEventListener('change', function () {
        if (tabs[this.value]) tabs[this.value].click();
      });
    }
  });

  // --------------- Sections

  const initializeSliders = () => {
  // Accordion Slider
  const accordionSections = document.querySelectorAll(".accordion-slider__container");
  accordionSections.forEach((section) => {
    const sliderEl = section.querySelector(".js-accordion-slider-splide");
    const accordionHeaders = section.querySelectorAll(".accordion-header");

    if (sliderEl && accordionHeaders.length > 0) {
      // 2. Initialize Splide for THIS specific section
      const splide = new Splide(sliderEl, {
        mediaQuery: "min",
        arrows: false,
        pagination: false,
        gap: "2rem",
        perPage: 1,
        perMove: 1,
        drag: false,
        speed: 600,
      }).mount();

      const activeHeader = section.querySelector('.accordion.active .accordion-header');
      const activeIndex = Array.from(accordionHeaders).indexOf(activeHeader);
      if (activeIndex > 0 && !sliderEl.classList.contains('accordion-slider__splide--static')) splide.go(activeIndex);

      // 3. Add click event to each accordion header within THIS section
      accordionHeaders.forEach((header) => {
        header.addEventListener("click", function () {
          // Get the index from the data attribute
          let indexValue = this.getAttribute("data-slide-index");

          // Handle the two different formats found in your Liquid code:
          // Format A: "accordion--1" (from metafields)
          // Format B: "0" (from blocks)
          let targetIndex = 0;

          if (indexValue.includes("--")) {
            // Extract number from "accordion--1" and convert to 0-based index
            targetIndex = parseInt(indexValue.split("--")[1]) - 1;
          } else {
            // It's already a number (0, 1, 2...)
            targetIndex = parseInt(indexValue);
          }

          // 4. Tell this specific Splide instance to go to that slide
          if (!isNaN(targetIndex)) {
            // Check for the static class before sliding
            if (!sliderEl.classList.contains("accordion-slider__splide--static")) {
              splide.go(targetIndex);
            }
          }
        });
      });
    }
  });

  const galleryGrid = document.querySelectorAll(".gallery-grid__container");
  galleryGrid.forEach((section) => {
    const sliderEl = section.querySelector(".js-gallery-grid__gallery");
    const splide = new Splide(sliderEl, {
      arrows: false,
      pagination: false,
      gap: "2rem",
      perPage: 1,
      perMove: 1,
      speed: 600,
    }).mount();
  });

  // Build off-screen carousels shortly before they enter view.
  function mountWhenNear(section, mount) {
    const observer = new IntersectionObserver((entries) => {
      if (entries.some((entry) => entry.isIntersecting)) {
        observer.disconnect();
        mount();
      }
    }, { rootMargin: "400px" });
    observer.observe(section);
  }

  const testimonialCarousel = document.querySelectorAll(".testimonial-carousel__container");
  testimonialCarousel.forEach((section) => mountWhenNear(section, () => {
    const sliderEl = section.querySelector(".js-testimonial-carousel__testimonials");
    const splide = new Splide(sliderEl, {
        mediaQuery: "min",
        perPage: 1,
        arrows: false,
        pagination: false,
        pauseOnHover: false,
        type: "loop",
        drag: true,
        gap: 0,
        padding: {
          right: "1rem"
        },
        perMove: 1,
        autoScroll: {
          speed: 0.5,
        },
        breakpoints: {
          768: {
            perPage: 2,
            arrows: false,
          },
          1024: {
            perPage: 3,
          },
          1440: {
            perPage: 3,
            gap: "4rem",
          },
          1920: {
            perPage: 4,
          },
        },
      }).mount(window.splide.Extensions);
  }));

  const feedCustomEl = document.querySelectorAll(".feed-custom__container");
  feedCustomEl.forEach((section) => mountWhenNear(section, () => {
    const sliderEl = section.querySelector(".js-feed-custom-splide");
    const splide = new Splide(sliderEl, {
      perPage: 4,
      arrows: false,
      pagination: false,
      pauseOnHover: false,
      type: "loop",
      perMove: 1,
      autoplay: true,
      speed: 2000,
      breakpoints: {
        767: {
          perPage: 1,
          gap: "2rem",
          arrows: true,
        },
        1023: {
          perPage: 2,
        },
        1439: {
          perPage: 3,
        },
      },
    }).mount();
  }));

  const featuredProductCustomEl = document.querySelectorAll(".featured-product-custom__container");
  featuredProductCustomEl.forEach((section) => {
    const sliderEl = section.querySelector(".js-cards-splide");
    const splide = new Splide(sliderEl, {
      mediaQuery: "min",
      arrows: true,
      pagination: false,
      gap: "2rem",
      perPage: 1,
      perMove: 1,
      breakpoints: {
        768: {
          perPage: 1,
          padding: {
            right: "30%",
          },
        },
        1280: {
          perPage: 2,
          gap: "2.4rem",
          padding: {
            right: 0,
          },
        },
        1440: {
          perPage: 2,
          gap: "3.2rem",
          padding: {
            right: "150px",
          },
        },
      },
    }).mount();
  });
  };
  (window.dashclipSlidersReady || Promise.resolve()).then(initializeSliders).catch(console.error);
});

document.addEventListener('DOMContentLoaded', function() {
  // 1. Target the select dropdown and the inputs
  const selectField = document.querySelector('[name="contact[Who is this order for]"]');

  if (selectField) {
    const orgInput = document.querySelector('[name="contact[Organization]"]');
    const qtyInput = document.querySelector('[name="contact[Estimated quantity]"]');
    const budgetInput = document.querySelector('[name="contact[Budget]"]');
    const typeOrgInput = document.querySelector('[name="contact[Type of organization]"]');

    const workEmailInput = document.querySelector('[name="contact[Work Email]"]');
    const personalEmailInput = document.querySelector('[name="contact[Email]"]');

    if (orgInput && qtyInput && budgetInput && typeOrgInput && workEmailInput && personalEmailInput) {
      const btnSubmitText = document.querySelector('.cf-submit-row button[type="submit"] .cf-btn__label');

      // 2. Find their parent <div> wrappers so we hide the labels too
      const orgContainer = orgInput.closest('.cf-field');
      const qtyContainer = qtyInput.closest('.cf-field');
      const budgetContainer = budgetInput.closest('.cf-field');
      const typeOrgContainer = typeOrgInput.closest('.cf-field');
      const workEmailContainer = workEmailInput.closest('.cf-field');
      const personalEmailContainer = personalEmailInput.closest('.cf-field');

      function toggleFields() {
        // Check the selected value.
        // Note: If you instead meant to SHOW these fields for a club and HIDE them for yourself,
        // you can change the condition to: selectField.value === 'Myself or a gift'
        if (selectField.value === 'Myself or a gift') {

          // Hide the containers
          orgContainer.style.display = 'none';
          qtyContainer.style.display = 'none';
          budgetContainer.style.display = 'none';
          typeOrgContainer.style.display = 'none';
          workEmailContainer.style.display = 'none';
          personalEmailContainer.style.display = '';

          // Remove the required attribute so the form can still submit
          orgInput.required = false;
          orgInput.removeAttribute('aria-required');
          qtyInput.required = false;
          qtyInput.removeAttribute('aria-required');
          workEmailInput.required = false;
          workEmailInput.removeAttribute('aria-required');
          personalEmailInput.required = true;
          personalEmailInput.setAttribute('aria-required', 'true');

          btnSubmitText.innerText = 'Send My Request';

        } else {

          // Show the containers
          orgContainer.style.display = '';
          qtyContainer.style.display = '';
          budgetContainer.style.display = '';
          typeOrgContainer.style.display = '';
          workEmailContainer.style.display = '';
          personalEmailContainer.style.display = 'none';

          // Restore the required attribute
          orgInput.required = true;
          orgInput.setAttribute('aria-required', 'true');
          qtyInput.required = true;
          qtyInput.setAttribute('aria-required', 'true');
          workEmailInput.required = true;
          workEmailInput.setAttribute('aria-required', 'true');
          personalEmailInput.required = false;
          personalEmailInput.removeAttribute('aria-required');

          btnSubmitText.innerText = 'Get a Custom Quote';

        }
      }

      // 3. Listen for changes on the dropdown
      selectField.addEventListener('change', toggleFields);

      selectField.selectedIndex = 1;

      // 4. Run once immediately to set the correct initial state on page load
      toggleFields();
    }
  }

  const relatedProduct = document.querySelector('.featured-product-custom__wrapper');

  if (relatedProduct) {
    const relatedProductHeading = document.querySelector('.featured-product-custom__text');
    const exactHeight = relatedProductHeading.getBoundingClientRect().height;
    const integerHeight = relatedProductHeading.offsetHeight;
    relatedProduct.style.setProperty('--fp-heading-height', `${exactHeight}px`);
  }
});

function initContactForm(sectionId) {
  const form = document.getElementById(`cf-${sectionId}`);
  if (!form) return;

  // Shopify's hCaptcha interception can drop the return_to redirect and reload
  // this page with the success alert rendered — follow the redirect manually.
  const redirectInput = form.querySelector('input[name="return_to"]');
  if (form.querySelector('.cf-alert--success') && redirectInput && redirectInput.value) {
    window.location.replace(redirectInput.value);
    return;
  }

  const summary = document.getElementById(`cf-error-summary-${sectionId}`);
  const submitBtn = form.querySelector('.cf-submit-row button[type="submit"]');

  const errorElFor = (field) => {
    const wrap = field.closest('.cf-field');
    return wrap ? wrap.querySelector('.cf-field-error') : null;
  };

  const messageFor = (field) => {
    if (field.type === 'checkbox') return 'Please tick this box to continue.';
    if (field.validity.valueMissing) return 'This field is required.';
    if (field.validity.typeMismatch) return 'Please enter a valid value.';
    return 'Please check this field.';
  };

  const setError = (field, message) => {
    const errorEl = errorElFor(field);
    if (errorEl) errorEl.textContent = message || '';
    field.setAttribute('aria-invalid', message ? 'true' : 'false');
  };

  const fields = Array.from(form.querySelectorAll('input, select, textarea'))
    .filter((field) => field.type !== 'hidden' && field.name !== 'contact[__hp]');

  fields.forEach((field) => {
    field.addEventListener('input', () => {
      if (field.checkValidity()) setError(field, '');
    });
    field.addEventListener('change', () => {
      if (field.checkValidity()) setError(field, '');
    });
  });

  form.addEventListener('submit', (event) => {
    const invalid = fields.filter((field) => !field.checkValidity());
    fields.forEach((field) => setError(field, field.checkValidity() ? '' : messageFor(field)));

    if (invalid.length) {
      event.preventDefault();
      if (summary) {
        summary.querySelector('.cf-error-summary__text').textContent =
          invalid.length === 1
            ? 'Please fix the highlighted field and try again.'
            : `Please fix the ${invalid.length} highlighted fields and try again.`;
        summary.classList.remove('cf-alert--hidden');
        summary.focus();
      }
      invalid[0].focus();
      return;
    }

    if (summary) summary.classList.add('cf-alert--hidden');

    // Shopify requires an input literally named contact[email]. Fields use
    // custom names (e.g. contact[Work Email]), so mirror the active email
    // into a hidden contact[email] input before the post.
    if (!form.querySelector('input[name="contact[email]"]')) {
      const emailFields = fields.filter((field) => field.type === 'email');
      const active = emailFields.find((field) => field.offsetParent !== null && field.value.trim())
        || emailFields.find((field) => field.value.trim());
      if (active) {
        const hidden = document.createElement('input');
        hidden.type = 'hidden';
        hidden.name = 'contact[email]';
        hidden.value = active.value.trim();
        form.appendChild(hidden);
      }
    }

    if (submitBtn) {
      submitBtn.disabled = true;
      submitBtn.classList.add('cf-btn--loading');
      const label = submitBtn.querySelector('.cf-btn__label');
      if (label && submitBtn.dataset.loadingText) label.textContent = submitBtn.dataset.loadingText;
    }
  });
}